export const metricDefinitionsSelector = (state: any) => state.metricDefinitions;

export const selectAnalyticsMetricDefinitions = (state: any) =>
  metricDefinitionsSelector(state).analyticsMetricDefinitions;

export const selectHighLevelMetricDefinitions = (state: any) =>
  metricDefinitionsSelector(state).highLevelMetricDefinitions;
